import React, { useState } from 'react'
import { MenuItem, Typography } from '@material-ui/core'
import { SelectFormsy } from '@fuse'
import { useIntl } from 'react-intl'
import { TextInput } from 'app/components/FormsyHelperComponent'
import useStyles from './customFieldsStyle'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import {
  Popover,
  Card,
  CardHeader,
  CardActions,
  CardContent,
} from '@material-ui/core'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import {
  CONTACT_INFO_DEFAULT_METHOD,
  TEXT,
  PHONE_NUMBER,
  contactType,
  CONTACT,
} from './constants'

const CustomContactForm = ({
  newCustomDialogStyle,
  name,
  label,
  saveCustomLabel,
}) => {
  const styleClass = useStyles()
  const { formatMessage } = useIntl()

  const [customContactField, setCustomContactField] = useState({
    labelType: CONTACT_INFO_DEFAULT_METHOD,
    label: '',
    fieldType: PHONE_NUMBER,
    subFields: [],
  })

  const handleSaveData = () => {
    saveCustomLabel(customContactField, CONTACT)
    setCustomContactField({
      ...customContactField,
      labelType: CONTACT_INFO_DEFAULT_METHOD,
      label: '',
      fieldType: PHONE_NUMBER,
    })
  }
  return (
    <div>
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div style={{ position: 'relative' }}>
            <div
              className={newCustomDialogStyle}
              style={{ cursor: 'pointer' }}
              {...bindTrigger(popupState)}
            >
              <AddCircleOutlineIcon color="secondary" />
              {name && <span>{name}</span>}
            </div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Card className={styleClass.cardStyle}>
                <CardHeader
                  title={formatMessage({
                    id: 'crm.custom.field.add.contact.information',
                  })}
                  className={styleClass.cardHeaderStyle}
                />
                <CardContent>
                  <div>
                    <SelectFormsy
                      className="w-full"
                      name={customContactField.labelType}
                      label={formatMessage({ id: label })}
                      value={customContactField.labelType}
                      variant="standard"
                      onChange={(event) => {
                        setCustomContactField({
                          ...customContactField,
                          labelType: event.target.value,
                          fieldType:
                            event.target.value === 'Phone'
                              ? PHONE_NUMBER
                              : TEXT,
                        })
                      }}
                    >
                      {contactType.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          <Typography>{formatMessage({ id: item })}</Typography>
                        </MenuItem>
                      ))}
                    </SelectFormsy>
                    <div className={styleClass.fieldWrapper}>
                      <TextInput
                        margin="dense"
                        containerClassName="MuiFormControl-fullWidth"
                        labelId={formatMessage({
                          id: 'crm.custom.field.input.label.name',
                        })}
                        placeholderId={formatMessage({
                          id: 'crm.custom.field.input.label.name',
                        })}
                        variant="standard"
                        fullWidth
                        name="customContact"
                        onChange={(event) => {
                          setCustomContactField({
                            ...customContactField,
                            label: event.target.value,
                          })
                        }}
                      />
                    </div>
                  </div>
                </CardContent>
                <CardActions className={styleClass.actionsWrapper}>
                  <CancelButton
                    className={styleClass.actionBtn}
                    onClick={() => {
                      popupState.setOpen(false)
                    }}
                  >
                    {formatMessage({ id: 'action.cancel' })}
                  </CancelButton>
                  <PrimaryButton
                    type="submit"
                    className={styleClass.actionBtn}
                    disabled={!customContactField.label.length > 0}
                    onClick={() => {
                      popupState.setOpen(false)
                      handleSaveData()
                    }}
                  >
                    {formatMessage({ id: 'action.ok' })}
                  </PrimaryButton>
                </CardActions>
              </Card>
            </Popover>
          </div>
        )}
      </PopupState>
    </div>
  )
}

export default CustomContactForm
